// Created by administrator on 2017/8/11

export default [
    {
        path: '/',
        name: 'projectmanagement',
        component: resolve => require(['../components/views/contract/welcome.vue'], resolve)
    },

    {
        path: 'projectList',
        name: 'projectList',
        component: resolve => require(['../components/views/contract/project/projectList.vue'], resolve)
    },

    {
        path: 'projectList2',
        name: 'projectList2',
        component: resolve => require(['../components/views/contract/project/projectList2.vue'], resolve)
    },

    {
        path: 'chargeDetailList',
        name: 'chargeDetailList',
        component: resolve => require(['../components/views/contract/chargeDetails/chargeDetailList.vue'], resolve)
    },

    {
        path: 'jixiaoChargeDetailList',
        name: 'jixiaoChargeDetailList',
        component: resolve => require(['../components/views/contract/chargeDetails/jixiaoChargeDetailList.vue'], resolve)
    },

    {
        path: 'performanceList',
        name: 'performanceList',
        component: resolve => require(['../components/views/contract/performance/performanceList.vue'], resolve)
    },

    {
        path: 'managerPerformanceList',
        name: 'managerPerformanceList',
        component: resolve => require(['../components/views/contract/performance/managerPerformanceList.vue'], resolve)
    },


    {
        path: 'statistics',
        name: 'statistics',
        component: resolve => require(['../components/views/contract/statistics.vue'], resolve)
    },


    {
        path: 'statistics4anxia',
        name: 'statistics4anxia',
        component: resolve => require(['../components/views/contract/statistics4anxia.vue'], resolve)
    },

    {
        path: 'changzhistatistics',
        name: 'changzhistatistics',
        component: resolve => require(['../components/views/contract/changzhistatistics.vue'], resolve)
    },

    {
        path: 'changzhistatistics4anxia',
        name: 'changzhistatistics4anxia',
        component: resolve => require(['../components/views/contract/changzhistatistics4anxia.vue'], resolve)
    },


    {
        path: 'statisticsyear',
        name: 'statisticsyear',
        component: resolve => require(['../components/views/contract/statisticsyear.vue'], resolve)
    },

    {
        path: 'statisticsyear4anxia',
        name: 'statisticsyear4anxia',
        component: resolve => require(['../components/views/contract/statisticsyear4anxia.vue'], resolve)
    },


    {
        path: 'statisticsClose',
        name: 'statisticsClose',
        component: resolve => require(['../components/views/contract/statisticsClose.vue'], resolve)
    },


    {
        path: 'statisticsClose4anxia',
        name: 'statisticsClose4anxia',
        component: resolve => require(['../components/views/contract/statisticsClose4anxia.vue'], resolve)
    },


    {
        path: 'advanceDrillingReportBaseInfo',
        name: 'advanceDrillingReportBaseInfo',
        component: resolve => require(['../components/views/contract/advanceDrilling/advanceDrillingReportBaseInfo.vue'], resolve)
    },


    {
        path: 'advanceDrillingReport',
        name: 'advanceDrillingReport',
        component: resolve => require(['../components/views/contract/advanceDrilling/advanceDrillingReport.vue'], resolve)
    },

    {
        path: 'signManager',
        name: 'signManager',
        component: resolve => require(['../components/views/contract/reportManager/signManager.vue'], resolve)
    },

    {
        path: 'feeStandard',
        name: 'feeStandard',
        component: resolve => require(['../components/views/contract/feeManager/feeStandard.vue'], resolve)
    },

    {
        path: 'feeManager',
        name: 'feeManager',
        component: resolve => require(['../components/views/contract/feeManager/feeManager.vue'], resolve)
    },

    {
        path: 'buildingAreaManager',
        name: 'buildingAreaManager',
        component: resolve => require(['../components/views/contract/feeManager/buildingAreaManager.vue'], resolve)
    },

    {
        path: 'checkbuildingAreaMonthManager',
        name: 'checkbuildingAreaMonthManager',
        component: resolve => require(['../components/views/contract/feeManager/checkbuildingAreaMonthManager.vue'], resolve)
    },

    {
        path: 'checkbuildingAreaStatistics',
        name: 'checkbuildingAreaStatistics',
        component: resolve => require(['../components/views/contract/feeManager/checkbuildingAreaStatistics.vue'], resolve)
    },
    {
        path: 'feeNoticeReport',
        name: 'feeNoticeReport',
        component: resolve => require(['../components/views/contract/feeManager/feeNoticeReport.vue'], resolve)
    },

    {
        path: 'reortTemplate',
        name: 'reortTemplate',
        component: resolve => require(['../components/views/contract/report/reortTemplate.vue'], resolve)
    },


    {
        path: 'RJybgBase',
        name: 'RJybgBase',
        component: resolve => require(['../components/views/contract/report/RJybgBase.vue'], resolve)
    },



    {
        path: 'reportperformanceList',
        name: 'reportperformanceList',
        component: resolve => require(['../components/views/contract/reportManager/reportperformanceList.vue'], resolve)
    },

    {
        path: 'printView',
        name: 'printView',
        component: resolve => require(['../components/views/contract/print/printView.vue'], resolve)
    },








]




// WEBPACK FOOTER //
// ./src/router/contract.js